import type { ChatMessage } from "@do/shared-types";
import { ChatCustomBlockTypes } from "@do/shared-types";
import axios, { AxiosError } from "axios";
import type { TFunction } from "i18next";

export function isNetworkError(error: unknown) {
  return (
    axios.isAxiosError(error) &&
    (error.code === AxiosError.ERR_NETWORK || error.code === AxiosError.ECONNABORTED)
  );
}

export function getGenericErrorMessage(t: TFunction<"errors", undefined>): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("genericError"),
      },
    ],
  };
}

export function getNetworkErrorMessage(t: TFunction<"errors", undefined>): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("networkError"),
      },
    ],
  };
}

export function getOutOfCreditsErrorMessage(t: TFunction<"errors", undefined>): ChatMessage {
  return {
    blocks: [
      {
        type: ChatCustomBlockTypes.text,
        text: t("disabledChatbotError"),
      },
    ],
  };
}

export function getMessageForError(t: TFunction<"errors", undefined>, error: unknown): ChatMessage {
  return isNetworkError(error) ? getNetworkErrorMessage(t) : getGenericErrorMessage(t);
}
